/*
 * @Author: zhushitao
 * @Date: 2021-07-21 15:14:17
 * @LastEditors: zhushitao
 * @LastEditTime: 2021-08-05 18:03:21
 * @Description:
 */
export enum Lang {
  zh = 'zh',
  es = 'es',
}

export enum Region {
  cn = 'cn',
  sg = 'sg',
}
